'use es6';

import { getAvailableOfferIdsForSku, getLowestTermsOfferId, getOfferId, getOfferInfo, getProductBasedOfferId, getCrmSuiteOfferId, getAvailableTermsForSku, getOfferIdForQueryParamTerm, getQueryParamTermForOfferId, getValidatedQueryParamTermForSku, getLowestCommonOfferId, getCommonAvailableOfferIds, getLowestCommonPaymentTerm, getCrmSuiteOfferIdFromQueryParam, getValidatedQueryParamTermForCrmSuite, getCrmSuiteAvailableTerms, getMatchingTermsOfferId, getCommonPaymentTerms, getCrmSuiteLowestTermsOfferId, getCrmSuiteHighestTermsOfferId, getHighestTermsOfferId, getCommonAvailableTerms, getCrmSuiteProductLevelForOfferId, getCrmSuiteQuantityPackOfferId } from 'pricing-pages-lib/utils/offerUtils';
import { ANNUAL } from 'self-service-api/constants/Terms';
import { createSelectorFromUtil } from 'pricing-pages-lib/utils/selectorUtils';
import { transformState } from './SelectorUtils';
export const termsMatch = (...terms) => {
  if (terms.length === 1) return true;

  for (let i = 1; i < terms.length; i++) {
    if (terms[i].commitment !== terms[0].commitment || terms[i].payment !== terms[0].payment) {
      return false;
    }
  }

  return true;
};
export const offerInfoSelector = createSelectorFromUtil(getOfferInfo, transformState);
export const discountPercentageSelector = (state, {
  offerId
}) => {
  const offerInfo = offerInfoSelector(state, {
    offerId
  });
  return offerInfo && offerInfo.discount;
}; // Returns a list of offer ids available for a SKU

export const availableOfferIdsForSkuSelector = createSelectorFromUtil(getAvailableOfferIdsForSku, transformState);
export const isAnnualDiscountEligibleSelector = (state, {
  skuId
}) => {
  const availableOfferIds = availableOfferIdsForSkuSelector(state, {
    skuId
  });
  return availableOfferIds.some(offerId => {
    const {
      payment,
      discount
    } = offerInfoSelector(state, {
      offerId
    });
    return payment === ANNUAL && discount > 0;
  });
};
export const productBasedOfferIdSelector = createSelectorFromUtil(getProductBasedOfferId, transformState);
export const availableTermsForSkuSelector = createSelectorFromUtil(getAvailableTermsForSku, transformState);
export const offerIdSelector = createSelectorFromUtil(getOfferId, transformState); // Finds the offer id that gives the lowest commitment / payment terms available
// for a specific SKU

export const lowestTermsOfferIdSelector = createSelectorFromUtil(getLowestTermsOfferId, transformState);
export const highestTermsOfferIdSelector = createSelectorFromUtil(getHighestTermsOfferId, transformState);
export const crmSuiteAvailableTermsSelector = createSelectorFromUtil(getCrmSuiteAvailableTerms, transformState);
export const crmSuiteLowestTermsOfferIdSelector = createSelectorFromUtil(getCrmSuiteLowestTermsOfferId, transformState);
export const crmSuiteHighestTermsOfferIdSelector = createSelectorFromUtil(getCrmSuiteHighestTermsOfferId, transformState);
export const crmSuiteOfferIdSelector = createSelectorFromUtil(getCrmSuiteOfferId, transformState);
export const offerIdForQueryParamTermSelector = createSelectorFromUtil(getOfferIdForQueryParamTerm, transformState);
export const queryParamTermForOfferIdSelector = createSelectorFromUtil(getQueryParamTermForOfferId, transformState);
export const crmSuiteOfferIdFromQueryParamSelector = createSelectorFromUtil(getCrmSuiteOfferIdFromQueryParam, transformState);
export const validatedQueryParamTermForSkuSelector = createSelectorFromUtil(getValidatedQueryParamTermForSku, transformState);
export const validateQueryParamTermForCrmSuiteSelector = createSelectorFromUtil(getValidatedQueryParamTermForCrmSuite, transformState);
export const commonAvailableOfferIdsSelector = createSelectorFromUtil(getCommonAvailableOfferIds, transformState);
export const lowestCommonOfferIdSelector = createSelectorFromUtil(getLowestCommonOfferId, transformState);
export const commonPaymentTermsSelector = createSelectorFromUtil(getCommonPaymentTerms, transformState);
export const lowestCommonPaymentTermsSelector = createSelectorFromUtil(getLowestCommonPaymentTerm, transformState);
export const matchingTermsOfferIdSelector = createSelectorFromUtil(getMatchingTermsOfferId, transformState);
export const commonAvailableTermsSelector = createSelectorFromUtil(getCommonAvailableTerms, transformState);
export const crmSuiteProductLevelForOfferIdSelector = createSelectorFromUtil(getCrmSuiteProductLevelForOfferId, transformState);
export const crmSuiteQuantityPackOfferIdSelector = createSelectorFromUtil(getCrmSuiteQuantityPackOfferId, transformState);